export default function ProtestsHistory() {
  return (
    <div className="dashboard">
      <h1>Protests History</h1>
      <p>
        Employee engagement in protests and union-organizing activities over
        time.
      </p>
      <br />
      <iframe
        src="https://app.powerbi.com/reportEmbed?reportId=ae1facbb-34ad-4681-a836-c6c400cc2c30&autoAuth=true&ctid=b699068d-c14b-454b-a0bc-10918cf075d3"
        title="Protests History Dashboard"
        width="100%"
        height="1000"
      ></iframe>
    </div>
  );
}
